import { render, staticRenderFns } from "./PapercleanDocumentiTrasformaEditPage.vue?vue&type=template&id=c231741e"
import script from "./PapercleanDocumentiTrasformaEditPage.vue?vue&type=script&lang=js"
export * from "./PapercleanDocumentiTrasformaEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports